import React, { useEffect, useRef, useState } from 'react';

const MOBILE_BREAKPOINT = 768;

const DOCS_URL = 'https://github.com/all-completed/tuning-proxy/blob/main/docs/API.md';
const GITHUB_URL = 'https://github.com/all-completed/tuning-proxy';
const SUPPORT_MAILTO = 'mailto:vasilii.vazhesov@gmail.com';

const LINKS = [
  { label: 'Docs', href: DOCS_URL },
  { label: 'GitHub', href: GITHUB_URL },
  { label: 'Support', href: SUPPORT_MAILTO }
];

function NavLinks({ navLinkStyle, theme }) {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== 'undefined' && window.innerWidth <= MOBILE_BREAKPOINT
  );
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const update = () => setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);

  useEffect(() => {
    if (!menuOpen) return;
    const close = () => setMenuOpen(false);
    document.addEventListener('click', close);
    return () => document.removeEventListener('click', close);
  }, [menuOpen]);

  const handleMenuClick = (e) => {
    e.stopPropagation();
    setMenuOpen((prev) => !prev);
  };

  if (!isMobile) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 14, flexWrap: 'wrap' }}>
        {LINKS.map(({ label, href }) => (
          <a key={label} style={navLinkStyle} href={href} target="_blank" rel="noreferrer">
            {label}
          </a>
        ))}
      </div>
    );
  }

  return (
    <div ref={menuRef} style={{ position: 'relative' }}>
      <button
        type="button"
        onClick={handleMenuClick}
        aria-label="Open menu"
        aria-expanded={menuOpen}
        style={{
          appearance: 'none',
          background: 'transparent',
          border: 'none',
          padding: 8,
          cursor: 'pointer',
          color: 'inherit',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <line x1="3" y1="6" x2="21" y2="6" />
          <line x1="3" y1="12" x2="21" y2="12" />
          <line x1="3" y1="18" x2="21" y2="18" />
        </svg>
      </button>
      {menuOpen && (
        <div
          role="menu"
          style={{
            position: 'absolute',
            top: '100%',
            right: 0,
            marginTop: 8,
            minWidth: 140,
            padding: '8px 0',
            background: theme?.cardBg || 'rgba(255, 255, 255, 0.98)',
            border: `1px solid ${theme?.border || 'rgba(0, 0, 0, 0.08)'}`,
            borderRadius: 12,
            boxShadow: '0 10px 40px rgba(0, 0, 0, 0.12)',
            zIndex: 100
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {LINKS.map(({ label, href }) => (
            <a
              key={label}
              href={href}
              target="_blank"
              rel="noreferrer"
              role="menuitem"
              onClick={() => setMenuOpen(false)}
              style={{
                ...navLinkStyle,
                display: 'block',
                padding: '10px 16px',
                textDecoration: 'none'
              }}
            >
              {label}
            </a>
          ))}
        </div>
      )}
    </div>
  );
}

export default NavLinks;
